import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Form, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMobileAlt, faTabletAlt, faGlobeAsia, faUserCircle, faWindowMaximize } from '@fortawesome/free-solid-svg-icons'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { updateUser, viewUser, addUserRole, removeUserRole } from "../Network/User"
import { useHistory, useParams } from 'react-router-dom'
import { Loading, HeaderTitle } from '../Library'
import { listCompany } from '../Network/Company'
import { listDepartment, addUserToDepartment, removeFromDepartment } from '../Network/Department'
import { listRole } from '../Network/Role'
import MultiSelect from "react-multi-select-component";
import "./VisitorDetail.css"
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from "../Role/RoleContext"
import axios from 'axios'
import { wtc5214,visitor8082 } from '../Network/Config'

function CreateSecurity(props) {
    console.log(props.company);
    const langCx = useContext(LanguageContext);
    const lang = langCx.lang.user
    const notifyCx = useContext(NotifyContext);
    const history = useHistory();
    const { securityId } = useParams();

    const [isLoading, setLoading] = useState(false);
    const [loadingTitle, setLoadingTitle] = useState("Loading");

    const [securityVisitor, setSecurityVisitor] = useState([])
    const [securityName, setSecurityName] = useState("");
    const [companyName, setCompanyName] = useState("")
    const [isError, setError] = useState(false);


    const [role, setRole] = useState([])

    useEffect(() => {
        setDocumentTitle("Create Security")
    }, [])


    const onSubmit = () =>{
        if( !securityName ){ 
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        setLoadingTitle(lang.updating)
        setLoading(true);
        updateSecurity(securityName);
        /*updateUser(
            securityName,
            ()=>{
            },
            (error)=>{
                setLoading(false)
                notifyCx.showNotify("Error", error.message, 2)
            }
        )*/
    }
    
    const updateSecurity = async (name) =>{
        const formDataUpdate = new FormData();
        formDataUpdate.append('company_name', props.company);
        formDataUpdate.append('security_name', name);
        const responseData = await axios.post(visitor8082+'/visitor/api/v1/security_add', formDataUpdate);
        setLoading(false)
        history.push("/visitor_security")
    }

    return (
        <>
        { isLoading ? <Loading title={loadingTitle}/>: null }
        <div id="create-user">
            <HeaderTitle title={'เพิ่มรายชื่อรปภ.'} isShowBack backTo="/visitor_security"/>
            <Row style={{width: "100%"}}>
                <Col className="content-container" md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        onSubmit();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{'ชื่อรปภ.'}</Form.Label>
                            <Form.Control
                            placeholder="ชื่อรปภ."
                            value={securityName}
                            isInvalid={isError && !securityName}
                            onChange={(e)=>setSecurityName(e.target.value)}
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{'บันทึกรายชื่อใหม่'}</Button>
                        </Form.Group>
                        
                    </Form>
                </Col>
            </Row>
        </div>
        </>
    )
}

function AccessItem(props){
    return(
        <div className="access-item"
        onClick={props.onClick}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                props.onClick()
            }
        }}
        style={{
            borderColor: props.isError ? "red": "lightgray",
            color: props.isSelected ? "white" : "black",
            backgroundColor: props.isSelected ? "#0275d8": "white"
        }}
        >
            <div>
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon}/>
                </div>
                <div className="title">{props.title}</div>
            </div>
        </div>
    )
}

function RoleList(){
    return(
        <div>
            <b className="title-role">Role</b>
            <div>
                <div className="role-item">
                    <div>System admin</div>
                    <div className="desc">Description here</div>
                </div>
            </div>
        </div>
    )
}

export default CreateSecurity
